<div
  [ngClass]="{ 'flex-wrap': !gallery.config.limitToOneRow }"
  #thumbContainer
  class="gallery-thumbnails-container flex-row"
>
  @for (thumb of gallery.items | slice: 0 : limitTo; track thumb.Id; let i = $index) {
    <gallery-thumb-item
      [moreCount]="gallery.items.length - limitTo"
      [newsId]="gallery.newsId"
      [ngClass]="{
        firstItem: i === 0,
        lastItem: gallery.config.limitToOneRow && i + 1 === gallery.config.rowItems,
        'flex-grow-0': !gallery.config.limitToOneRow,
      }"
      [ngStyle]="{
        height: thumbHeight + 'px',
        width: gallery.config.limitToOneRow ? 'auto' : 100 / gallery.config.rowItems + '%',
      }"
      [showAllLayer]="
        gallery.config.limitToOneRow &&
        gallery.items.length > gallery.config.rowItems &&
        i === gallery.config.rowItems - 1
      "
      [thumbItem]="thumb"
      (click)="showPreview(i)"
      class="flex-auto"
    ></gallery-thumb-item>
  }
</div>
